export const PAGE_CHANGE = "PAGE_CHANGE";
export const ROWS_PER_PAGE_CHANGE = "ROWS_PER_PAGE_CHANGE";
export const INITIAL_PAGE = "INITIAL_PAGE";
